var map = {
	"./BDE.PNG": 7934,
	"./body_text.jpg": 180,
	"./bw.gif": 6034,
	"./people2.png": 1146,
	"./schedule2.PNG": 4264,
	"./vday.jpg": 6551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1940;